import React, { useEffect } from "react";
import { NavLink, useNavigate } from 'react-router-dom';
import { API_URL } from "./config";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const More = () => {
    const navigate = useNavigate();
    const [isMinistryAdmin, setIsMinistryAdmin] = React.useState(false);
    const [isCellGrpAdmin, setIsCellGrpAdmin] = React.useState(false);

    // Dummy function for navigation (replace with your actual navigation logic)
    const handleNavigation = (page) => {
        console.log(`Navigating to ${page}`);
        // Add your navigation logic here
    };

    useEffect(() => {
        const asyncFetch = async () => {
            console.log("Checking if you are ministry or cell grp admin");
            // const apiLink = Apilink.getLink();

            const asynctoken = await localStorage.getItem("Tkn");
            const memberId = await localStorage.getItem("UserID");

            try {
                let res1 = await fetch(
                    `${API_URL}/ministries/ministry-leaders/${memberId}`,
                    {
                        method: "get",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                let responseJson1 = await res1.json();
                if (responseJson1.length != 0) {
                    setIsMinistryAdmin(true);
                }
            } catch {
                setIsMinistryAdmin(false);
            }

            try {
                let res2 = await fetch(
                    `${API_URL}/smallgroups/smallgroups-leaders/${memberId}`,
                    {
                        method: "get",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                let responseJson2 = await res2.json();
                if (responseJson2.length != 0) {
                    setIsCellGrpAdmin(true);
                }
            } catch {
                setIsCellGrpAdmin(false);
            }
        }

        asyncFetch();
    }, []);


    return (
        <div style={styles.container}>
            <div style={styles.headerContainer}>
                <button onClick={() => navigate(-1)} style={styles.backButton}>
                    <ArrowBackIcon style={styles.backIcon} />
                </button>
                <h4 style={styles.heading}>More</h4>
            </div>
            <div style={styles.menuContainer}>
                {/* My Profile Card */}
                <NavLink to="/myprofile" style={{ textDecoration: 'none' }}>
                    <div
                        style={styles.card}
                        onClick={() => handleNavigation("My Profile")}
                    >
                        <div style={styles.cardContent}>
                            <span style={styles.cardText}>My Profile</span>
                            <span style={styles.cardIcon}><i className="material-icons" style={{ fontSize: '1.7rem', color: '#00000090' }}>person</i></span>
                        </div>
                    </div>
                </NavLink>

                {/* Profile Settings Card */}
                <NavLink to="/settings" style={{ textDecoration: 'none' }}>
                    <div
                        style={styles.card}
                        onClick={() => handleNavigation("Profile Settings")}
                    >
                        <div style={styles.cardContent}>
                            <span style={styles.cardText}>Profile Settings</span>
                            <span style={styles.cardIcon}><i className="material-icons" style={{ fontSize: '1.5rem', color: '#00000090' }}>settings</i></span>

                        </div>
                    </div>
                </NavLink>

                {/* Family Members (Kids) Card */}
                {/* <NavLink to="/kids" style={{ textDecoration: 'none' }}>
                    <div
                        style={styles.card}
                        onClick={() => handleNavigation("Family Members (Kids)")}
                    >
                        <div style={styles.cardContent}>
                            <span style={styles.cardText}>Family Members (Kids)</span>
                            <span style={styles.cardIcon}><i className="material-icons" style={{ fontSize: '1.5rem', color: '#00000090' }}>groups</i></span>

                        </div>
                    </div>
                </NavLink> */}

                {isMinistryAdmin && (
                    <NavLink to="/selectministry" style={{ textDecoration: 'none' }}>
                        <div
                            style={styles.card}
                            onClick={() => handleNavigation("Ministry Admin")}
                        >
                            <div style={styles.cardContent}>
                                <span style={styles.cardText}>Ministry Admin</span>
                                <span style={styles.cardIcon}><i className="material-icons" style={{ fontSize: '1.5rem', color: '#00000090' }}>person</i></span>

                            </div>
                        </div>
                    </NavLink>
                )}
                {isCellGrpAdmin && (
                    <NavLink to="/selectcell" style={{ textDecoration: 'none' }}>
                        <div
                            style={styles.card}
                            onClick={() => handleNavigation("Cell Group Admin")}
                        >
                            <div style={styles.cardContent}>
                                <span style={styles.cardText}>Cell Group Admin</span>
                                <span style={styles.cardIcon}><i className="material-icons" style={{ fontSize: '1.5rem', color: '#00000090' }}>person</i></span>

                            </div>
                        </div>
                    </NavLink>
                )}

                {/* About Card */}
                <NavLink to="/about" style={{ textDecoration: 'none' }}>
                    <div
                        style={styles.card}
                        onClick={() => handleNavigation("About")}
                    >
                        <div style={styles.cardContent}>
                            <span style={styles.cardText}>About</span>
                            <span style={styles.cardIcon}><i className="material-icons" style={{ fontSize: '1.5rem', color: '#00000090' }}>info</i></span>
                        </div>
                    </div>
                </NavLink>

                {/* Sign Out Card */}
                <NavLink to="/" style={{ textDecoration: 'none' }}>
                    <div
                        style={styles.card}
                        onClick={() => handleNavigation("Sign Out")}
                    >
                        <div style={styles.cardContent}>
                            <span style={styles.cardText}>Sign Out</span>
                            <span style={styles.cardIcon}><i className="material-icons" style={{ fontSize: '1.5rem', color: '#00000090' }}>logout</i></span>

                        </div>
                    </div>
                </NavLink>
            </div>
        </div>
    );
};

// Styles
const styles = {
    container: {
        padding: "20px",
        maxWidth: "500px",
        margin: "0 auto",
        marginBottom: "60px",
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: '800px',
        marginBottom: '15px',
        position: 'relative'
    },
    backButton: {
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        borderRadius: '50%',
        marginRight: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s ease',
        ':hover': {
            backgroundColor: '#f0f2f5'
        }
    },
    backIcon: {
        color: '#1a6363',
        fontSize: '28px'
    },
    heading: {
        flex: 1,
        textAlign: 'center',
        fontSize: '24px',
        color: '#1a6363',
        fontWeight: '600',
        margin: 0,
        paddingRight: '52px'
    },
    menuContainer: {
        width: "100%",
        maxWidth: "500px",
    },
    card: {
        // backgroundColor: "#ffffff",
        backgroundColor: "#f5f5f5",
        border: "1px solid #1a6363",
        borderRadius: "8px",
        padding: "15px",
        margin: "10px 0",
        cursor: "pointer",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        transition: "background-color 0.3s ease",
    },
    cardContent: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    cardText: {
        fontSize: "16px",
        color: "#1a6363",
    },
    cardIcon: {
        fontSize: "20px",
    },
};

export default More;